module.exports = __webpack_public_path__ + "img/gxz.e31f9cb0.jpg";